
function initMatchpint(){
	//if container div exists then we are on the right page and need to run function
	if( $('#matchpint-container').length ){

		var matchpintFeedURL 	= '/wp-content/themes/duplo/library/php/fetch-matchpint.php?matchpintID='
		var matchpintID 		= $('#matchpint-container').attr('data-matchpint-id'); //Grabbing the id

		//load the matchpint data direct to on-page div
		if(matchpintID){
			//alert(matchpintID);
			$('#matchpint-container').load(matchpintFeedURL+matchpintID+' .bar-fixtures__container', function(){
				//Succesfully loaded the feed!
				$('.m__matchpint').addClass('loaded');
			});
		}
	}
}